import { AxiosResponse } from 'axios'
import { http } from '../api'
import { Season } from '../model'
import { format } from 'date-fns'
import { GoalsGroup } from '../model/GoalsGroup'
const controller = 'goals-group'

export async function getPaginate(page?: number, size?: number, name?: string, start_date?: Date, end_date?: Date, isExport?: boolean): Promise<any> {
    const url = `${controller}/?u=u${page ? `&page=${page}` : ''}${size ? `&page_length=${size}` : ''}${(name ? `&name=${name}` : '')}${start_date ? `&start_date=${format(start_date, 'yyyy-MM-dd')}` : ''}${end_date ? `&end_date=${format(end_date, 'yyyy-MM-dd')}` : ''}${isExport ? `&export=true` : ''}`;
    const { data } = await http.get<any, AxiosResponse>(url); 
    return data;
}

export async function getBy(id: string): Promise<any> {
    const { data } = await http.get<any, AxiosResponse>(`${controller}/${id}`)
    return data;
}

export async function create(payload: GoalsGroup): Promise<GoalsGroup> {
    const { data } = await http.post<GoalsGroup, AxiosResponse>(`${controller}/`, payload)
    return data;
}
export async function deleted(id: number): Promise<boolean> {

    const { status } = await http.delete(`${controller}/${id}`);

    return status === 204;
}